module.exports = __webpack_public_path__ + "img/yingyong_icon02.201bdcae.png";